var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51648 0.520955C1.30495 0.309421 0.961981 0.309421 0.750447 0.520955C0.538913 0.732489 0.538913 1.07545 0.750447 1.28699L4.00045 4.53699C4.21198 4.74852 4.55495 4.74852 4.76648 4.53699L8.01648 1.28699C8.22801 1.07545 8.22801 0.732489 8.01648 0.520955C7.80495 0.309421 7.46198 0.309421 7.25045 0.520955L4.38346 3.38794L1.51648 0.520955Z",
    fill: "#575756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDown);
export default __webpack_public_path__ + "static/media/sidebar-down.7e3d1ac325c11f05f61b1af19539589d.svg";
export { ForwardRef as ReactComponent };